import { render } from "./StartSurveyButton.vue?vue&type=template&id=48285148&scoped=true"
import script from "./StartSurveyButton.vue?vue&type=script&lang=js"
export * from "./StartSurveyButton.vue?vue&type=script&lang=js"

import "./StartSurveyButton.vue?vue&type=style&index=0&id=48285148&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48285148"]])

export default __exports__